<template lang="pug">
  .intro-card
    tilt-card(:img="img" :copy="copy" @clicked="onClick")
  
</template>
<script>
import TiltCard from '@/components/home/TiltCard'
import { mapMutations } from 'vuex'
const introductionImg = require('src/assets/introduction2.png')
export default {
  name: 'IntroCard',
  components: { TiltCard },
  props: {},
  data() {
    return {
      img: introductionImg,
      copy: {
        cn: '展项介绍',
        en: 'Introduction',
      },
    }
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onClick() {
      this.$router.replace('/introduction/intro')
      this.setRouterBack('/')
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
.intro-card
  width: 100%
  height: 100%
</style>
